import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SnackbarProvider } from './contexts/SnackbarContext';
import GetStarted from './pages/GetStarted';
import Incident from './pages/Incident';
import InventoryList from './pages/InventoryList';
import AddInventoryItem from './pages/AddInventoryItem';
import EditInventoryItem from './pages/EditInventoryItem';
import InventoryDraftSaved from './pages/InventoryDraftSaved';
import ClaimStatusPage from './pages/ClaimStatusPage';
import Success from './pages/Success';
import './styles/main.css';

function App() {
  return (
    <SnackbarProvider anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/" element={<GetStarted />} />
          <Route path="/claim/:token" element={<GetStarted />} />
          <Route path="/claim-status" element={<ClaimStatusPage />} />
          <Route path="/claim/:token/status" element={<ClaimStatusPage />} />
          <Route path="/incident" element={<Incident />} />
          <Route path="/damages" element={<InventoryList />} />
          <Route path="/damages/add" element={<AddInventoryItem />} />
          <Route path="/damages/edit/:itemId" element={<EditInventoryItem />} />
          <Route path="/damages/saved" element={<InventoryDraftSaved />} />
          <Route path="/success" element={<Success />} />
        </Routes>
      </Router>
    </SnackbarProvider>
  );
}

export default App; 